import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { FiltersCard } from "components/Common/FiltersCard"
import Table from "./Table"
import axios from "axios";
import {API_URL, sitename} from "../../../constants/constants";
import moment from "moment";
const JackpotReport = props => {
  const [item, setItem] = useState("All")
  const [jackpotReport, setJackpotReport] = useState([])
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  useEffect(() => {
    call()
  }, [])
  const call = () => {
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/jackpot-name-wise-report?from=${fromDate}&to=${toDate}&market=${item}`,
    })
        .then(function (response) {
          setJackpotReport(response?.data?.data)
        })
        .catch(function (response) {
          //handle error
          //  showErrorMessages(response)
        })
  }
  const option = [
    { label: "All", value: "All" },
    { label: "1x2", value: "1x2" },
    { label: "u/0 2.5", value: "u/0 2.5" },
    { label: "BTTS", value: "BTTS" },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Jackpot Report" />
        </Container>
        <FiltersCard item={item}
                     setItem={setItem}
                     options={option}
                     toDate={toDate}
                     setToDate={d => setToDate(d)}
                     setFromDate={d => setFromDate(d)}
                     filterLabel="Market"
                     fromDate={fromDate}
                     call={() => {
                       call()
                     }}
                     hideShowType={false}
        />
        <Table data={jackpotReport} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(JackpotReport)
